import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';

import Panel from 'components/Panel/Panel';

import { useAuth } from 'utils/auth';

import styles from './auth.scss';

export default function Auth() {
    const auth = useAuth();
    const navigate = useNavigate();
    const { t } = useTranslation();

    React.useEffect(() => {
        // Handle keypress event.
        document.addEventListener('keypress', handleDocumentKeyPress);
        document.body.style.background = '#FFFFFF';

        // if (wildcard !== undefined && wildcard !== "localhost") {
        //     window.location.replace(window.location.origin + "/company/" + wildcard);
        // }

        // Component Will Unmount
        return () => {
            document.removeEventListener('keypress', handleDocumentKeyPress);
            document.body.style = null;
        };
    }, []);

    React.useEffect(() => {
        // if we are logged in, redirect to pages.
        if (auth.user && auth.user.access_token) {
            if (auth.company !== null) {
                navigate('/pages', { replace: true });
            } else {
                navigate('/companies', { replace: true });
            }
        }
    });

    /**
     * Handle document
     * @param {event} e KeyPress event.
     */
    function handleDocumentKeyPress(e) {
        const keycode = e.keyCode ? e.keyCode : e.which;

        if (keycode === '13') {
            // Click on the focused element.
            document.activeElement.click();
        }
    }

    function createUnsubscribeUrl() {
        const url = new URL(window.location);
        url.pathname = '/me';

        return url;
    }

    return (
        <Panel fill={true} contentStyles={{ display: 'flex', height: '100%', alignItems: 'center' }}>
            <div className={styles.auth}>
                <div className={styles.left}>
                    <div className={styles.aboutApp}>
                        <div
                            className={styles.logo}
                            onClick={() => {
                                navigate('/');
                            }}
                        />
                        <p className={styles.text}>{t('welcome.leftSide.description')}</p>
                    </div>

                    <div className={styles.unsubscribe}>
                        <a href={createUnsubscribeUrl()}>Я хочу отменить подписку</a>
                    </div>
                </div>
                <div className={styles.right}>
                    <Outlet />
                </div>
            </div>
        </Panel>
    );
}
